<template>
  <div>

<v-snackbar dark v-model="snackbar" :timeout="4000" top>
      <span>You just added a new solution concept.</span>
      <v-btn flat color="primary" @click="snackbar = false">Close</v-btn>
    </v-snackbar>


    <v-layout row wrap align-center justify-center class="mt-3">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
          <v-card
            class="text-xs-center ma-3"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-card-title>
                 <v-layout row wrap align-center justify-center class="mt-2">
                <span class="headline font-weight-bold">Let's rank the solutions based on preference:</span>

              <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify"
                outline>
                Tip: To start with, it is ideal to add as many solutions as possible. The relevant solutions can then be shortlisted and the ideal solution option can be selected at the end.
              </v-alert> -->
                 </v-layout>
            </v-card-title>
            <v-card-text>

                

              <v-form class="px-3" ref="form">
                <!-- <span v-for="(customerproblemdetail, index) in customerproblemdetails" :key="index"> -->
                  <!-- <v-layout row wrap>  
                    <Popup @projectadded="snackbar = true" /> -->
                <v-spacer></v-spacer>

 <v-container grid-list-md>

                  <v-layout align-center justify-center>


    <v-flex wrap>

     <!--<span v-for="(solutionconcept, index) in solutionconcepts" :key="index"> 
         {{items[index] =  solutionconcept.nameofthesolution}}
    </span>   -->
      
<v-select 
          v-model="firstprefsolutionconcept"  
          :items="items"
          :label="ranking[0]"
          :rules="selectInputRules" 
          outline 
        ></v-select>

 <v-select
          v-model="secondprefsolutionconcept"
          :items="items"
          :label="ranking[1]"
          :rules="selectInputRules" 
          outline
        ></v-select>

<v-select
          v-model="thirdprefsolutionconcept"  
          :items="items"
          :label="ranking[2]"
          :rules="selectInputRules" 
          outline
        ></v-select>    

    <!-- </span>              -->

    </v-flex>

  </v-layout>

 </v-container>

                 
                <v-spacer></v-spacer>
                
                <v-btn flat @click="$router.go(-1)" class="mx-4">Head back</v-btn>
                <!-- <v-btn flat @click="submitPreference" color="primary" class="mx-2 mt-3">Confirm Preference</v-btn>   -->
                <Popupaddrankjustification @firstprefdetailsconfirmed="submitPreference" />  <!-- to="/bifdashboard" -->
                
              </v-form>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import db from '../fb'
import Popupaddrankjustification from '../components/Popupaddrankjustification'
import gvars from '../globalvariables'

export default {
  name: "problemstudy",
  components: {
    Popupaddrankjustification
  },
  data() {
    return {  
        firstprefsolutionconcept: 'Tasks using E-Method',
        secondprefsolutionconcept: 'ToDo list using GTD',
        thirdprefsolutionconcept: 'Goal management system using POSEC',
      solutionconcepts: [], 
      //items: ['Enterprise', 'Consumer', 'Both Enterprise and Consumer', 'Not Sure'],
     items: [], 
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      snackbar: false,
      ranking: ['First Preference or Ideal solution', 'Second Preference', 'Third Preference']
    }
  },
  methods: {
    submit(){
      //console.log(this.dropdownList[1].isEnabled)
      
 if(this.$refs.form.validate()) {
        //console.log("Attempt to submit")
        const project = {

          projecttitle: this.projecttitle,
          customerproblemdescription: this.customerproblemdescription,
          whythisproblem: this.whythisproblem,
          targetagerange: this.targetagerange,
          problemdomain: this.problemdomain,
          additionaldetailforproblem: this.additionaldetailforproblem
        }


        db.collection('projects').add(project).then(function() {
                // Housekeeping
                //console.log("Document written with ID: ", docRef.id);
            });
            // .catch(function(error) {
            //     console.error("Error adding document: ", error);
            // });
        }

    },
    submitPreference(){

        if(this.$refs.form.validate()) {


            const prefdetails = {
                firstprefsolutionconcept: this.firstprefsolutionconcept,
                secondprefsolutionconcept: this.secondprefsolutionconcept,
                thirdprefsolutionconcept: this.thirdprefsolutionconcept
            }

            //details['prefs'] = firstprefdetails;
 

            //
            //xuWrU7qOYXxLjL97QoCe

            db.collection('projects').doc(this.getProjectID()).update(prefdetails).then(() => {
          //console.log("added to db!", docRef.id)
          //this.loading = false;
          //this.dialog = false;
          //this.$emit('firstprefdetailsconfirmed')
          this.snackbar = true
            this.$router.push('addproductgoals')
       });


            
        }

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
  },
  computed: {
    // listOfSolutions(){ 
    //     return this.solutionconcepts.forEach(solutionconcept => {
    //             this.items.push(solutionconcept.nameofthesolution)
    //   })    

    // },
    // remainingConcepts(){
    //   return this.solutionconcepts.filter(solutionconcept => {
    //     return solutionconcept.nameofthesolution == firstpref
    //   })
    // }
  },
  created(){
    db.collection('projects').doc('HR19rr0ZLH8fCrOtxq7R').collection('solutionconcepts').onSnapshot(res => {

      const changes = res.docChanges();

      changes.forEach(change => {
        if (change.type === 'added'){
          this.solutionconcepts.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        //   this.items.push(this.solutionconcepts.nameofthesolution)
        //   console.log(this.items)
        }
      });

                this.solutionconcepts.forEach(solutionconcept => {
                this.items.push(solutionconcept.nameofthesolution)

                 
 })  
    })

  }
};
</script>

<style>
.rounded-card{
  border-radius:20px;
}
</style>
